import PropTypes from 'prop-types';
import React from 'react';
import { MEASURE_NAMES } from '../../../constants/assessments';
import {
    constructDibels8Link,
    linkOnClickHandler,
    PAGE_TYPE,
} from '../../../common/navigation/navigation';
import { useAppContext } from '../../../common/contexts/AppContext';
import { usePopupContext } from '../../../common/contexts/PopupContext';
import MeasureScore from '../measure-score/MeasureScore';

const D8MeasureScore = ({
    isFromAssessmentImporter,
    score,
    interpretation,
    studentId,
    measure,
    period,
    classId,
    resultId,
    isFormAvailable,
}) => {
    const { checkAndGetSessionStatus } = useAppContext();
    const {
        actions: { showMazeScorePopup, showNoDetailsAvailablePopup, showAINoDetailsAvailablePopup },
    } = usePopupContext();

    if (isFromAssessmentImporter) {
        return (
            <MeasureScore
                score={score}
                interpretation={interpretation}
                onClick={showAINoDetailsAvailablePopup}
            />
        );
    }
    if (measure === MEASURE_NAMES.MAZE) {
        return (
            <MeasureScore
                score={score}
                interpretation={interpretation}
                onClick={showMazeScorePopup}
            />
        );
    }

    if (!isFormAvailable) {
        return (
            <MeasureScore
                score={score}
                interpretation={interpretation}
                onClick={showNoDetailsAvailablePopup}
            />
        );
    }

    const path = constructDibels8Link(studentId, measure, PAGE_TYPE.REVIEW, {
        period,
        classId,
        resultId,
    });

    return (
        <MeasureScore
            score={score}
            interpretation={interpretation}
            path={path}
            onClick={linkOnClickHandler(path, checkAndGetSessionStatus)}
        />
    );
};

D8MeasureScore.propTypes = {
    score: PropTypes.number,
    interpretation: PropTypes.string,
    studentId: PropTypes.string.isRequired,
    measure: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    classId: PropTypes.string.isRequired,
    resultId: PropTypes.string,
    isFormAvailable: PropTypes.bool,
    isFromAssessmentImporter: PropTypes.bool,
};

D8MeasureScore.defaultProps = {
    score: undefined,
    resultId: '',
    interpretation: '',
    isFormAvailable: true,
    isFromAssessmentImporter: false,
};

export default D8MeasureScore;
